/**
 * Assets/custom-product.js
 */
(function() {
  /* ==========================================================================
     1. 从全局配置读取数据并初始化
     ========================================================================== */
  const config = window.ShopifyUserConfig || {};

  const ShopifyUser = {
    isLoggedIn: config.isLoggedIn || false,
    id: config.id || '',
    email: config.email || '',
    apiBase: "https://akapi.angelkiss.cn",
    shopDomain: "gdi3bk-n0.myshopify.com",
    productId: config.productId || ''
  };

  // 向下兼容老代码变量
  window.customerEmail = ShopifyUser.isLoggedIn ? ShopifyUser.email : null;
  window.shopDomain = ShopifyUser.shopDomain;
  window.productId = ShopifyUser.productId;

  const getProductSubmitQuick = () => document.querySelector('.product__submit__quick');
  const getVariantInput = () => document.querySelector('.xqy-variant-id') || document.querySelector('input[name="id"]');
  const getWishlistBtn = () => document.querySelector('.xqy-wishlist-btn');
  const getEmailBtn = () => document.querySelector('.email-notification-button');

  let isSubscribed = false;
  let loading = false;

  /* ==========================================================================
     2. 用户浏览足迹追踪逻辑 (History Preview)
     ========================================================================== */
  function trackCurrentVariant() {
    const urlParams = new URLSearchParams(window.location.search);
    let rawVariantId = urlParams.get('variant') || config.defaultVariantId;
    const variantId = String(rawVariantId).replace(/.*variant=/, '').trim();
    
    const title = config.productTitle;

    let imageUrl = "";
    const activeImageImg = document.querySelector([
      '.product__media-list .is-active img', '.product__media-item.is-active img',
      '[data-product-single-media-wrapper] img', '.product-gallery__image--active',
      '.product-featured-img', '.product__main-photos img', '#ProductPhotoImg'
    ].join(','));

    if (activeImageImg && activeImageImg.src) { imageUrl = activeImageImg.src; }

    if (!imageUrl || imageUrl.includes('blank.gif')) {
      try {
        const jsonEl = document.querySelector('[id^="VariantsJson-"], [data-product-json], #ProductJson-');
        if (jsonEl) {
          const productJson = JSON.parse(jsonEl.textContent);
          const currentVariantObj = productJson.variants.find(v => String(v.id) === variantId);
          if (currentVariantObj && currentVariantObj.featured_image) {
            imageUrl = currentVariantObj.featured_image.src;
          }
        }
      } catch (e) {}
    }

    if (!imageUrl) {
      imageUrl = config.defaultVariantFeaturedImage || config.featuredImage;
    }

    if (imageUrl && imageUrl.startsWith('//')) { imageUrl = 'https:' + imageUrl; }

    let price = config.defaultVariantPrice;
    const priceEl = document.querySelector('.price-item--regular, .product__price .money, .price .price__regular .price-item');
    if (priceEl) { price = priceEl.textContent.trim(); }

    let variantTitle = "";
    const activeVariantEl = document.querySelector('.variant-js-select, input[type="radio"]:checked+label, .product-form__input input:checked+label, .fieldset input:checked+label');
    if (activeVariantEl) {
      variantTitle = activeVariantEl.textContent.trim() || activeVariantEl.value;
    } else {
      variantTitle = config.defaultVariantTitle;
    }
    if (variantTitle === "Default Title") { variantTitle = ""; }

    const productUrl = window.location.pathname + (window.location.search ? window.location.search : `?variant=${variantId}`);

    const historyItem = {
      variantId: variantId,
      title: title,
      variantTitle: variantTitle,
      price: price,
      imageUrl: imageUrl,
      url: productUrl,
      timestamp: new Date().getTime(),
      productCreatedAt: config.productCreatedAt || "", // 👈 已新增此字段，其余保留代码二配置
      views: 1 
    };

    if (ShopifyUser.isLoggedIn) {
      fetch(`${ShopifyUser.apiBase}/UKHistoryPreview/history/sync`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId: ShopifyUser.id,
          email: ShopifyUser.email,
          historyItem: historyItem
        })
      })
      .then(res => res.json())
      .catch(err => console.error("Database sync failed:", err));
    } else {
      let historyList = JSON.parse(localStorage.getItem('shopify_history_preview')) || [];
      const existingItem = historyList.find(item => String(item.variantId) === variantId);
      if (existingItem) {
        historyItem.views = (parseInt(existingItem.views) || 1) + 1;
      }
      historyList = historyList.filter(item => String(item.variantId) !== variantId);
      historyList.unshift(historyItem);
      if (historyList.length > 20) { historyList.pop(); }
      localStorage.setItem('shopify_history_preview', JSON.stringify(historyList));
    }
  }

  /* ==========================================================================
     3. 货到通知与心愿单交互核心
     ========================================================================== */
  async function triggerEmailNotification() {
    const email = window.customerEmail;
    if (!email || email === "null") {
      if (typeof showPopUp === "function") showPopUp('Please login to subscribe.'); else alert('Please login to subscribe.');
      return false; 
    }

    const variantInput = getVariantInput();
    const variantId = variantInput?.value;
    if (!variantId) {
      alert('Variant ID not found. Please refresh and try again.');
      return false;
    }

    const wishlistButton = getWishlistBtn();
    const productTitle = wishlistButton?.getAttribute('data-product-title') || config.productTitle;
    const productUrl = window.location.href;
    const selectedImg = document.querySelector('.is-selected img') || document.querySelector('.product__media img');
    const productImage = selectedImg ? selectedImg.src : config.featuredImage;
    const variantTitle = wishlistButton?.getAttribute('data-variant-title') || "";

    try {
      const res = await fetch(`${ShopifyUser.apiBase}/UKhuodao/subscribe`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          shop: ShopifyUser.shopDomain,
          productId: ShopifyUser.productId,
          variantId,
          email,
          productTitle,
          productUrl,
          productImage,
          variantTitle
        })
      });
      const data = await res.json();
      if (data.success) {
        isSubscribed = true;
        updateUI();
        return true;
      }
      return false;
    } catch (err) {
      console.error('Fetch error:', err);
      return false;
    }
  }

  function updateUI() {
    const emailBtn = getEmailBtn();
    if (!emailBtn) return;
    const btnText = emailBtn.querySelector('.email-notification-text');
    if (!btnText) return;
    
    if (isSubscribed) {
      emailBtn.classList.add('is-subscribed');
      emailBtn.title = "We will send you an email notification once the item is in stock.";
      btnText.innerText = "Do not notify me";
    } else {
      emailBtn.classList.remove('is-subscribed');
      emailBtn.title = "Notify me via email when items are in stock.";
      btnText.innerText = "Notify me";
    }
  }

  async function initSubscribeStatus() {
    const email = window.customerEmail;
    const variantInput = getVariantInput();
    const variantId = variantInput?.value;

    if (!email || email === "null" || !variantId) {
      isSubscribed = false;
      updateUI();
      return;
    }

    try {
      // 保持代码二原有的 /huodao/ 前缀路由
      const res = await fetch(
        `${ShopifyUser.apiBase}/UKhuodao/subscription-status?shop=${ShopifyUser.shopDomain}&variantId=${variantId}&email=${encodeURIComponent(email)}`
      );
      const data = await res.json();
      isSubscribed = data.subscribed;
      updateUI();
    } catch (err) {
      isSubscribed = false;
      updateUI();
    }
  }

  function updateReserveBox() {
    const reserveBox = document.querySelector('.Reserve-box');
    const productSubmitQuick = getProductSubmitQuick();
    const selectedInput = document.querySelector('.radio__button.on input');
    const BtnAddToCart = document.querySelector('.btn--add-to-cart');
    const XqyWishlistBtn = getWishlistBtn();
    const PREORDERSBtn = document.querySelector('.variant__countdown--PRE-ORDERS');
    const PreOrderTXT = document.querySelector('.Pre-Order-TXT');

    if (!reserveBox || !productSubmitQuick || !BtnAddToCart) return;

    if (selectedInput && selectedInput.classList.contains('No-stock')) {
      if(PreOrderTXT) PreOrderTXT.style.display = 'block';
      if(PREORDERSBtn) PREORDERSBtn.style.display = 'block';
      reserveBox.style.display = 'block';
      productSubmitQuick.style.display = 'none';
      BtnAddToCart.disabled = true;
      BtnAddToCart.classList.add('disabled');
      BtnAddToCart.style.display = 'none';

      if (XqyWishlistBtn) {
        XqyWishlistBtn.disabled = true;
        XqyWishlistBtn.classList.add('disabled');
        XqyWishlistBtn.style.pointerEvents = 'none';
        XqyWishlistBtn.style.display = 'none';
      }
    } else {
      if(PreOrderTXT) PreOrderTXT.style.display = 'none';
      if(PREORDERSBtn) PREORDERSBtn.style.display = 'none';
      reserveBox.style.display = 'none';
      productSubmitQuick.style.display = 'block';
      BtnAddToCart.disabled = false;
      BtnAddToCart.classList.remove('disabled');
      BtnAddToCart.style.display = 'block';

      if (XqyWishlistBtn) {
        XqyWishlistBtn.disabled = false;
        XqyWishlistBtn.classList.remove('disabled');
        XqyWishlistBtn.style.pointerEvents = '';
        XqyWishlistBtn.style.display = 'block';
      }
    }
  }

  /* ==========================================================================
     4. DOM 构建与事件集中挂载
     ========================================================================== */
  document.addEventListener('DOMContentLoaded', function () {
    
    // 特殊包装页面清理逻辑
    if (window.location.pathname === '/products/packaging') {
      const reserveBox = document.querySelector('.Reserve-box');
      const paymentProductButtons = document.querySelector('.shopify-payment-button');
      const productSubmitQuick = getProductSubmitQuick();
      if (reserveBox) reserveBox.innerHTML = '';
      const wishlistBtn = getWishlistBtn();
      if (wishlistBtn) wishlistBtn.innerHTML = '';
      if (productSubmitQuick) productSubmitQuick.innerHTML = '';
      if (paymentProductButtons) paymentProductButtons.innerHTML = '';
    }

      // 规格按钮基础点击事件
    const radioButtons = document.querySelectorAll('.radio__button');
    radioButtons.forEach(function(button) {
      button.addEventListener('click', function () {
        radioButtons.forEach(btn => btn.classList.remove('on'));
        this.classList.add('on');

        const wishlistButton = getWishlistBtn();
        if (!wishlistButton) return;

        const img = this.querySelector('label img');
        const imgAlt = img ? img.alt : '';

        // 延迟 50ms 确保主题原生脚本已更新 input 的 value 和 DOM 状态
        setTimeout(() => {
          const variantInput = getVariantInput();
          const variantId = variantInput ? variantInput.value : null;

          const selectedImg = document.querySelector('.is-selected img') || document.querySelector('.product__media img');
          const DataVariantUrl = window.location.href;

          // 集中同步更新心愿单按钮属性
          wishlistButton.setAttribute('data-variant-id', variantId);
          wishlistButton.setAttribute('data-variant-title', imgAlt);
          if (selectedImg) {
            wishlistButton.setAttribute('data-product-image', selectedImg.src);
          }
          wishlistButton.setAttribute('data-product-url', DataVariantUrl);
        }, 50); // 调整为 50ms 避开主题逻辑的渲染时差
      });
    });

    // 绑定规格切换执行
    updateReserveBox();
    document.querySelectorAll('.radio__button input').forEach(input => {
      input.addEventListener('change', updateReserveBox);
    });

    // 心愿单交互
    const detailWishlistBtn = getWishlistBtn();
    if (detailWishlistBtn) {
      detailWishlistBtn.addEventListener('click', function () {
        const productId = this.getAttribute('data-product-id') || ShopifyUser.productId;
        const variantInput = getVariantInput();
        const variantId = this.getAttribute('data-variant-id') || variantInput?.value;
        const productTitle = this.getAttribute('data-product-title') || config.productTitle;
        const productUrl = this.getAttribute('data-product-url') || window.location.href;
        const selectedImg = document.querySelector('.is-selected img') || document.querySelector('.product__media img');
        const productImage = this.getAttribute('data-product-image') || selectedImg?.src || config.featuredImage;
        const variantTitle = this.getAttribute('data-variant-title') || "";

        const rawPrice = this.getAttribute('data-product-price') || config.defaultVariantPrice;
        const productPrice = rawPrice ? String(rawPrice).replace(',', '.').replace(/[^0-9.]/g, '') : '';

        // const productPrice = this.getAttribute('data-product-price') || config.defaultVariantPrice;

        let wishlist = JSON.parse(localStorage.getItem('shopify_wishlist')) || [];
        const index = wishlist.findIndex(item => item.variantId === variantId);

        if (index === -1) {
          wishlist.push({ productId, variantId, productTitle, productUrl, productImage, variantTitle, productPrice });
          localStorage.setItem('shopify_wishlist', JSON.stringify(wishlist));
          this.classList.add('is-active');
          if (typeof showPopUp === "function") showPopUp('Added to wishlist successfully!'); else alert('Added to wishlist!');
        } else {
          wishlist.splice(index, 1);
          localStorage.setItem('shopify_wishlist', JSON.stringify(wishlist));
          this.classList.remove('is-active');
          if (typeof showPopUp === "function") showPopUp('Removed from wishlist.'); else alert('Removed from wishlist.');
        }

        document.dispatchEvent(new CustomEvent('wishlist:update', { detail: { wishlist: wishlist } }));
      });
    }

    // 订阅到货通知点击
    const emailBtn = getEmailBtn();
    if (emailBtn) {
      emailBtn.addEventListener('click', async function () {
        if (loading) return;
        loading = true;

        const email = window.customerEmail;
        const variantInput = getVariantInput();
        const variantId = variantInput?.value;

        if (!email || email === "null" || !variantId) {
          if (typeof showPopUp === "function") showPopUp('Please login to subscribe.'); else alert('Please login to subscribe.');
          loading = false;
          return;
        }

        try {
          if (!isSubscribed) {
            const success = await triggerEmailNotification();
            if(success) {
              if (typeof showPopUp === "function") showPopUp('Notify you when the item is in stock.'); else alert('Subscribed!');
            }
          } else {
            // 保持代码二原有的 /huodao/unsubscribe 路由
            const res = await fetch(`${ShopifyUser.apiBase}/UKhuodao/unsubscribe`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ shop: ShopifyUser.shopDomain, variantId, email })
            });
            const data = await res.json();
            if (data.success !== false) {
              isSubscribed = false;
              updateUI();
              if (typeof showPopUp === "function") showPopUp('Canceled notifications.'); else alert('Canceled!');
            }
          }
        } catch (err) {
          console.error(err);
        } finally {
          loading = false;
        }
      });
    }

    // 预售按钮直接结账
    const reserveBtn = document.querySelector('.reserve-check-out-button');
    if (reserveBtn) {
      reserveBtn.addEventListener('click', async function () {
        const email = window.customerEmail;
        const variantInput = getVariantInput();
        
        if (!email || email === "null") {
          if (typeof showPopUp === "function") showPopUp('Please login to make a pre-sale purchase.'); else alert('Please login!');
          return;
        }

        if (!variantInput || !variantInput.value) {
          alert('Variant not found, please reselect product options.');
          return;
        }

        let quantity = 1;
        const quantityInput = document.querySelector('.quantity__input');
        if (quantityInput) { quantity = parseInt(quantityInput.value, 10) || 1; }

        await triggerEmailNotification();

        try {
          await fetch('/cart/clear.js', { method: 'POST' });
          const fd = new FormData();
          fd.append('id', variantInput.value);
          fd.append('quantity', quantity);
          fd.append('properties[Pre-Order]', 'Estimated to ship in 2–3 months');

          const res = await fetch('/cart/add.js', { method: 'POST', body: fd });
          if (!res.ok) {
            alert('This product is currently unavailable.');
            return;
          }
          window.location.href = '/checkout';
        } catch (e) {
          alert('Something went wrong, please try again.');
        }
      });
    }

    // 初始化足迹追踪及变体联动
    setTimeout(trackCurrentVariant, 200);
    initSubscribeStatus();

    // 监听 URL 及变体切换：同时刷新【足迹追踪】与【到货订阅状态】
    let lastUrl = window.location.href;
    const observer = new MutationObserver(() => {
      if (location.href !== lastUrl) {
        lastUrl = location.href;
        setTimeout(() => {
          trackCurrentVariant();
          initSubscribeStatus();
        }, 400); 
      }
    });
    if (document.querySelector('body')) {
      observer.observe(document.querySelector('body'), { subtree: true, childList: true });
    }
    
    document.addEventListener('variant:change', function() { 
      setTimeout(() => {
        trackCurrentVariant();
        initSubscribeStatus();
      }, 400); 
    });

  });
})();